import { FunctionComponent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { Dropdown } from "primereact/dropdown";

import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { translationKeys } from "../../../../models/app-translation-keys";
import { AppLanguageOptions } from "../../../../models/constants/app-language-options.const";
import { ILanguageOption } from "../../../../models/interfaces";
import { useStore } from "../../../../stores/StoreContext";

export const LanguageSelection: FunctionComponent = () => {
  const { t } = useTranslation();
  const { userStore } = useStore();

  const languageSelectionRef = useRef<Dropdown>(null);

  const [selectedLanguage, setSelectedLanguage] = useState<ILanguageOption>();

  const handleLanguageSelectButtonChange = (languageOption: ILanguageOption) => {
    setSelectedLanguage(languageOption);
    userStore.changeLanguage(languageOption);
  };

  useEffect(() => {
    const foundLanguage: ILanguageOption | undefined = AppLanguageOptions.find(
      option => option.code === userStore.currentLanguage.code,
    );
    setSelectedLanguage(foundLanguage);
  }, [userStore.currentLanguage]);

  const dropdownItemTemplate = (item: ILanguageOption) => {
    return <span>{t(translationKeys.language[item.code as keyof typeof translationKeys.language])}</span>;
  };
  const dropdownValueTemplate = (item: ILanguageOption) => {
    return <span>{item.code?.toUpperCase()}</span>;
  };

  return selectedLanguage ? (
    <Dropdown
      ref={languageSelectionRef}
      value={selectedLanguage}
      onChange={event => handleLanguageSelectButtonChange(event.value)}
      options={AppLanguageOptions}
      className="plain"
      name="language-dropdown"
      itemTemplate={dropdownItemTemplate}
      dropdownIcon={<FontAwesomeIcon icon={faChevronDown} />}
      valueTemplate={dropdownValueTemplate}
    />
  ) : (
    <span>N/A</span>
  );
};
